import { render, staticRenderFns } from "./OrdersWeightModal.vue?vue&type=template&id=314aa6c6&"
import script from "./OrdersWeightModal.vue?vue&type=script&lang=js&"
export * from "./OrdersWeightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports